"use strict";

const baseURL = window._env_ ? window._env_.REACT_APP_API_PATH : 'localhost';
const clientPortalURL = window._env_ ? window._env_.REACT_APP_PORTAL_URL : 'localhost';
const cpaChargeClientId = (window._env_ && window._env_.REACT_APP_CPACHARGE_CLIENT_ID) || '06e274c0dcdc4ee60ba01209c75e30a6505c7d7a3420d9d8fb7ecee1af18f2fb';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL;
exports.clientPortalURL = clientPortalURL; 
exports.cpaChargeClientId = cpaChargeClientId;
